import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth } from "../../blocks/layout/columnSpans";

/**
 * Email Preference Group as page config. Created/modified details aren't fields here -
 * EntityPage summarises them in the footer.
 */
export const subscriptionGroupPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "g4c_subscriptiongroup",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: fullWidth,
          blocks: [
            {
              kind: "section",
              id: "section-email-preference-group",
              // The page bar already names the record.
              title: "",
              fields: [
                {
                  id: "field-g4c_name",
                  type: "text",
                  name: "g4c_name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: { desktop: 4, tablet: 6, mobile: 12 },
                },
                {
                  id: "field-g4c_sequencenumber",
                  type: "number",
                  name: "g4c_sequencenumber",
                  label: "Sequence",
                  span: { desktop: 2, tablet: 6, mobile: 12 },
                },
                {
                  id: "field-g4c_description",
                  type: "text",
                  name: "g4c_description",
                  label: "Description",
                  span: { desktop: 6, tablet: 12, mobile: 12 },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
